import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getPzMockPaperResult = ({ paperId }) =>
  httpClient.get(apis.GET_PZ_MOCK_PAPER_RESULT + paperId);
